/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken, AxiosInstance } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from 'utils';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IPortalPaymentMethods {
    getConfiguration(cancelToken?: CancelToken): AxiosPromise<PaymentMethodConfigurationResponse>;
    getPaymentsServiceProcessorAccountId(invoiceId: string, cancelToken?: CancelToken): AxiosPromise<FintechCustomerPortalApiResponseOfString>;
    getCreditCards(customerId: number, cancelToken?: CancelToken): AxiosPromise<FileResponse>;
    deleteCreditCard(customerId: number, cardId: number, cancelToken?: CancelToken): AxiosPromise<FileResponse>;
    saveCreditCard(creditCard: EditCreditCard, cancelToken?: CancelToken): AxiosPromise<FileResponse>;
    getBankAccounts(customerId: number, cancelToken?: CancelToken): AxiosPromise<FileResponse>;
    deleteBankAccount(customerId: number, bankAccountId: number, cancelToken?: CancelToken): AxiosPromise<FileResponse>;
    saveBankAccount(bankAccount: EditBankAccount, cancelToken?: CancelToken): AxiosPromise<FileResponse>;
    setPrimary(customerId: number, request: SetPrimaryPaymentMethodRequest, cancelToken?: CancelToken): AxiosPromise<FileResponse>;
}

export const BASE_URL_TOKEN_PortalPaymentMethods = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class PortalPaymentMethods implements IPortalPaymentMethods {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(private readonly axios: AxiosInstance, private readonly baseUrl = '') {
    }

    getConfiguration(cancelToken?: CancelToken): AxiosPromise<PaymentMethodConfigurationResponse> {
        let url_ = "/v1/customerportal2/savedpaymentmethods/configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(this.axios.request<PaymentMethodConfigurationResponse>(options_));
    }

    getPaymentsServiceProcessorAccountId(invoiceId: string, cancelToken?: CancelToken): AxiosPromise<FintechCustomerPortalApiResponseOfString> {
        let url_ = "/v1/customerportal2/savedpaymentmethods/paymentsservice/processoraccountid/invoice/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(this.axios.request<FintechCustomerPortalApiResponseOfString>(options_));
    }

    getCreditCards(customerId: number, cancelToken?: CancelToken): AxiosPromise<FileResponse> {
        let url_ = "/v1/customerportal2/savedpaymentmethods/{customerId}/creditcards";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            responseType: 'blob',
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(this.axios.request<FileResponse>(options_));
    }

    deleteCreditCard(customerId: number, cardId: number, cancelToken?: CancelToken): AxiosPromise<FileResponse> {
        let url_ = "/v1/customerportal2/savedpaymentmethods/{customerId}/creditcard/{cardId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (cardId === undefined || cardId === null)
            throw new Error("The parameter 'cardId' must be defined.");
        url_ = url_.replace("{cardId}", encodeURIComponent("" + cardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            responseType: 'blob',
            url: url_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(this.axios.request<FileResponse>(options_));
    }

    saveCreditCard(creditCard: EditCreditCard, cancelToken?: CancelToken): AxiosPromise<FileResponse> {
        let url_ = "/v1/customerportal2/savedpaymentmethods/creditcard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = creditCard;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            responseType: 'blob',
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(this.axios.request<FileResponse>(options_));
    }

    getBankAccounts(customerId: number, cancelToken?: CancelToken): AxiosPromise<FileResponse> {
        let url_ = "/v1/customerportal2/savedpaymentmethods/{customerId}/bankaccounts";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            responseType: 'blob',
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(this.axios.request<FileResponse>(options_));
    }

    deleteBankAccount(customerId: number, bankAccountId: number, cancelToken?: CancelToken): AxiosPromise<FileResponse> {
        let url_ = "/v1/customerportal2/savedpaymentmethods/{customerId}/bankaccounts/{bankAccountId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (bankAccountId === undefined || bankAccountId === null)
            throw new Error("The parameter 'bankAccountId' must be defined.");
        url_ = url_.replace("{bankAccountId}", encodeURIComponent("" + bankAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            responseType: 'blob',
            url: url_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(this.axios.request<FileResponse>(options_));
    }

    saveBankAccount(bankAccount: EditBankAccount, cancelToken?: CancelToken): AxiosPromise<FileResponse> {
        let url_ = "/v1/customerportal2/savedpaymentmethods/bankaccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = bankAccount;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            responseType: 'blob',
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(this.axios.request<FileResponse>(options_));
    }

    setPrimary(customerId: number, request: SetPrimaryPaymentMethodRequest, cancelToken?: CancelToken): AxiosPromise<FileResponse> {
        let url_ = "/v1/customerportal2/savedpaymentmethods/customers/{customerId}/primary";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = request;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            responseType: 'blob',
            url: url_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(this.axios.request<FileResponse>(options_));
    }
}

export interface PaymentMethodConfigurationResponse {
    isSavedCardFeatureEnabled: boolean;
    isSavedAchFeatureEnabled: boolean;
    isSavedPayByBankFeatureEnabled: boolean;
    isSavedPaymentFeatureEnabled: boolean;
}

export interface FintechCustomerPortalApiStatusResponse {
    status: number;
    errorMessages?: ErrorInfo[] | undefined;
}

export interface FintechCustomerPortalApiResponseOfString extends FintechCustomerPortalApiStatusResponse {
    result?: string;
}

/** Encapsulates error returned from the business logic layer to the service layer */
export interface ErrorInfo {
    /** Gets/sets a string error code that can be used also for resource file key etc for example INVALID_EMAIL_ADDRESS */
    errorCode?: string | undefined;
    /** Gets/sets the description (optional text description) */
    description?: string | undefined;
    /** Gets/sets the invalid parameter (relevant for 400 bad request). */
    invalidParameter?: string | undefined;
    /** Gets/sets the Gets/sets the invalid value of the invalid parameter */
    invalidValue?: string | undefined;
    /** Important to distinguish the source of the error, for our reporting/metrics/alerting.  */
    failedSource: FailedStatusSource;
}

export enum FailedStatusSource {
    NotSet = 0,
    Provider = 1,
    UserInput = 2,
    Backend = 3,
}

export interface CreditCard {
    id: number;
    cardholderName?: string | undefined;
    customerId: number;
    number?: string | undefined;
    expYear: number;
    expMonth: number;
    issuer: CreditCardIssuer;
    zip?: string | undefined;
    token?: string | undefined;
    isExpired: boolean;
    primary: boolean;
    membership: boolean;
    recentlyDeclined: boolean;
    membershipRecords?: MembershipRecord[] | undefined;
    paymentTypeId: number;
    paymentsServicePaymentMethodId?: string | undefined;
}

export interface EditCreditCard extends CreditCard {
    vaultId?: string;
    pgRequestId?: string;
    businessUnitId: number;
    cvv?: string;
    paymentProcessorType?: PaymentProcessorType;
}

export enum PaymentProcessorType {
    AuthorizeNet = 0,
    Worldpay = 1,
    Nmi = 2,
    ProfitStars = 3,
    Stripe = 4,
    PaymentGatewayGate = 5,
    Sears = 6,
    PaymentsService = 7,
}

export enum CreditCardIssuer {
    UnknownType = 0,
    AmericanExpress = 3,
    Visa = 4,
    Mastercard = 5,
    Discover = 6,
    Sears = 7,
}

export interface MembershipRecord {
    id: number;
    paymentMethodId?: number | undefined;
    paymentTypeId: number;
    customerId: number;
    typeName?: string | undefined;
}

export interface BankAccount {
    id: number;
    bankName?: string | undefined;
    customerName?: string | undefined;
    customerId: number;
    number?: string | undefined;
    zip?: string | undefined;
    token?: string | undefined;
    primary: boolean;
    membership: boolean;
    membershipRecords?: MembershipRecord[] | undefined;
    paymentTypeId: number;
    recentlyDeclined: boolean;
    routing?: string | undefined;
    paymentsServicePaymentMethodId?: string | undefined;
    isPayByBank: boolean;
}

export interface EditBankAccount extends BankAccount {
    businessUnitId: number;
}

export interface SetPrimaryPaymentMethodRequest {
    type?: PaymentInstrument | undefined;
    methodId?: number | undefined;
}

export enum PaymentInstrument {
    CreditCard = 0,
    BankAccount = 1,
    PayByBank = 2,
}

export type FileResponse = Blob;
